<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div fxLayout="column" fxFlex>
    <div class="report-selector" [ngClass]="{ 'report-selected': (selectedReport$ | async) }"
         fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 0 auto">
        @if (visibleDefinitions) {
            <mat-form-field>
                <mat-label>Choose a Report:</mat-label>
                <mat-select [ngModel]="selectedReportDefinition$ | async"
                            (ngModelChange)="setSelectedReport($event)"
                            [compareWith]="reportCompareFn"
                            panelClass="option-panel">
                    <mat-option [value]="undefined">-- Select --</mat-option>
                    @for (report of visibleDefinitions; track report.name) {
                        <mat-option [value]="report">{{ report.displayName }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (selectedReportDefinition$ | async; as definition) {
            @if (definition.subType !== 'csv') {
                <dash-gis-report-controls [definition]="definition"
                                          [keys]="objectKey"
                                          [digitizeKey]="digitizeKey$ | async"></dash-gis-report-controls>
            }
        }
    </div>
    @if (selectedReport$ | async; as selectedReport) {
        <ng-container
            *ngTemplateOutlet="reportType === 'feature' ? featureReport : dataReport; context: {$implicit: selectedReport}"></ng-container>
    }
</div>

<ng-template #featureReport let-selectedReport>
    <dash-gis-feature-report [showControls]="false"
                             [launchOptions]="selectedReport$ | async"
                             [uid]="createUid(uid, selectedReport?.definition.name)"
                             (recordCount)="setRecordCount($event)"
                             (clearReports)="clearReports()"
                             (widthUpdate)="onWidthUpdate($event)"
                             fxFlex fxLayout="column"></dash-gis-feature-report>
</ng-template>

<ng-template #dataReport let-selectedReport>
    <dash-gis-data-report [showControls]="false"
                          [launchOptions]="selectedReport$ | async"
                          [uid]="createUid(uid, selectedReport?.definition._name)"
                          (recordCount)="setRecordCount($event)"
                          (clearReports)="clearReports()" fxFlex
                          fxLayout="column"></dash-gis-data-report>
</ng-template>
